import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DsIconModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-link',
  imports: [DsIconModule, DsTooltipDirectiveModule],
  template: `
    @if (value()) {
      <a [attr.href]="makeLink()" [class.email-selection]="this.prefix() === 'mailto'">
        @for (part of parts(); track part) {
          <!-- no whitespace --><span class="email-part">{{ part }}</span
          ><!--  no whitespace  -->
        }
      </a>
    } @else {
      -
    }
  `,
  styleUrl: './cdf-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CdfLinkComponent {
  readonly i18n = useI18n();

  readonly prefix = input.required<'mailto' | 'tel'>();
  readonly value = input<string | undefined>(undefined);

  /**
   * Construct a clickable email or telephone link.
   *
   * Note that this should be bound to `<a>` with `[attr.href]` rather than `[href]`, to avoid binding blank links.
   */
  protected makeLink(): string | undefined {
    const value = this.value();
    if (!value) {
      return undefined;
    } else {
      return this.prefix() + ':' + value;
    }
  }

  // Split the email at the @-sign, to allow for long emails to wrap
  protected readonly parts = computed(() => this.value()?.split(/(?=@)/) ?? []);
}
